// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Ilx0y","inner":"Footer_inner__3mFYf"};